import { Store } from '@/Core/Models/Stores';
import { Component, MapGetter, mixins, Vue } from 'types-vue'
import ObtainVersionListMixin from '../../mixins/ObtainVersionList';

@Component
export default class Changelog extends mixins(ObtainVersionListMixin) {
  @MapGetter(Store.Versions) protected loading: boolean
}